import { render } from "./SlButton.vue?vue&type=template&id=0f3ed0ce&scoped=true"
import script from "./SlButton.vue?vue&type=script&lang=js"
export * from "./SlButton.vue?vue&type=script&lang=js"

import "./SlButton.vue?vue&type=style&index=0&id=0f3ed0ce&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3ed0ce"]])

export default __exports__